const validate = (values) => {
  const errors = {};
  if(!values.name) {
    errors.name = 'Company name field shouldn’t be empty';
  }
  if (!values.first_name) {
    errors.first_name = 'First name field shouldn’t be empty';
  }
  if(!values.last_name) {
    errors.last_name = 'Last name field shouldn’t be empty';
  }
  if (!values.email) {
    errors.email = 'Email field shouldn’t be empty';
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
    errors.email = 'Invalid email address';
  }

  return errors;
};

export default validate;
